import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

import { auth0 } from './auth'
import { store } from './store'
import { apolloProvider, VueApolloComponents } from './vue-apollo'
import { vDraggable } from './directives/vDraggable'

const app = createApp(App)

app.config.devtools = true
app.config.productionTip = false

app.config.globalProperties.$minDate = '1960-01-01T00:00:00.000Z'
app.config.globalProperties.$maxDate = '3000-12-31T00:00:00.000Z'

// Register custom directives
app.directive('draggable', vDraggable)

// https://github.com/auth0/auth0-vue/blob/main/EXAMPLES.md#protecting-a-route
app.use(router)
// "Note: the order in which the Router and Auth0 Vue plugin are registered is important.
// You must register the Router before the Auth0 SDK or you might see unexpected behavior."
app.use(auth0)
app.use(vuetify)
app.use(store)
app.use(apolloProvider)
app.use(VueApolloComponents)

app.mount('#app')
